import {
    GET_USERS,
    GET_USERS_SUCCESS,
    INVITE_USER,
    INVITE_USER_SUCCESS,
    INVITE_USER_FAILURE,
    UPDATE_USER,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    DELETE_USER,
    DELETE_USER_SECCESS
} from './constants';

/**
 *
 * @returns {{type: string}}
 */
const getUsers = () => (
    {
        type: GET_USERS
    }
);

/**
 *
 * @param users
 * @returns {{users: *, type: string}}
 */
const getUsersSuccess = (users) => ({
    type: GET_USERS_SUCCESS,
    users: users,
});

/**
 *
 * @param formData
 * @param resolve
 * @param reject
 * @returns {{reject: *, resolve: *, formData: *, type: string}}
 */
const inviteUser = (formData, resolve, reject) => ({
    type: INVITE_USER,
    formData,
    resolve,
    reject,
});

/**
 *
 * @param response
 * @returns {{type: string, response: *}}
 */
const inviteUserSuccess = (response) => ({
    type: INVITE_USER_SUCCESS,
    response
});

/**
 *
 * @param errors
 * @returns {{errors: *, type: string}}
 */
const inviteUserFailure = (errors) => ({
    type: INVITE_USER_FAILURE,
    errors
});

/**
 *
 * @param formData
 * @param resolve
 * @param reject
 * @returns {{reject: *, resolve: *, formData: *, type: string}}
 */
const updateUser = (formData, resolve, reject) => ({
    type: UPDATE_USER,
    formData,
    resolve,
    reject,
});

/**
 *
 * @param users
 * @returns {{type: string, users: *}}
 */
const updateUserSuccess = (users) => ({
    type: UPDATE_USER_SUCCESS,
    users
});

/**
 *
 * @param errors
 * @returns {{errors: *, type: string}}
 */
const updateUserFailure = (errors) => ({
    type: UPDATE_USER_FAILURE,
    errors
});

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const deleteUser = (id) => ({
    type: DELETE_USER,
    id
});

/**
 *
 * @param users
 * @returns {{users: *, type: string}}
 */
const deleteUserSuccess = users => ({
    type: DELETE_USER_SECCESS,
    users
});

export {
    getUsers,
    getUsersSuccess,
    inviteUser,
    inviteUserSuccess,
    inviteUserFailure,
    updateUser,
    updateUserSuccess,
    updateUserFailure,
    deleteUser,
    deleteUserSuccess,
};